import http from 'lc-http';

import { UPDATE_PROGRESS_BAR } from '../../store/actions/onboarding';

export const REVIEW_SUBMIT = 'REVIEW_SUBMIT';
export const REVIEW_SUBMIT_PROCESSING = 'REVIEW_SUBMIT_PROCESSING';
export const REVIEW_SUBMIT_COMPLETE = 'REVIEW_SUBMIT_COMPLETE';
const PROCESSING_SUBMIT = 'PROCESSING_SUBMIT';
const SUBMIT_COMPLETED = 'SUBMIT_COMPLETED';

const postConfirmation = () =>
  http.post('/patientsolutions/enroll/review', { variation: 'ALT' });

export const submitConfirmation = (submitFn = postConfirmation) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: PROCESSING_SUBMIT
      });
      submitFn()
        .then(({ data }) => {
          dispatch({
            type: UPDATE_PROGRESS_BAR,
            payload: { ...data, hasCompletedReview: true }
          });
          resolve();
        })
        .catch((err) => {
          dispatch({ type: REVIEW_SUBMIT, hasError: true });
          reject(err);
        })
        .finally(() => {
          dispatch({
            type: SUBMIT_COMPLETED
          });
        });
    });
  };
};

